import { parseInt } from "./parseInt.js";
export const Utils = {
    parseInt,
};
